import { BaseNavbar } from '@/components/layouts/base-navbar';

export function TenantNavbar() {
  return <BaseNavbar headerStyle="fixed" />;
}
